import { useTheme } from '@emotion/react';
import { Box, CssBaseline, useMediaQuery } from '@mui/material';
import { SnackbarProvider } from 'notistack';
import React, { useContext, useEffect, useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import ThankYouPage from '../../Components/KenApplicationForm/Components/ThankYouPage';
import KenLoader from '../../Components/KenLoader';
import KenPrivateRoute from '../../Components/KenPrivateRoute';
import MenuAppBar from '../../Components/MenuAppBar';
import SideNavigation from '../../Components/SideNavigation';
import {
  PERMISSIONS,
  ROLES,
  TABLET_BREAKPOINT,
} from '../../Constants/constant';
import routes from '../../Constants/routes';
import { useAppContext } from '../../Context/appContext';
import { AuthContext } from '../../Context/authContext';
import { ErrorFallback } from '../../Utils/ErrorBoundary';
import { getAxiosInstance, getConfig } from '../../Utils/apiServices';
import ApplicationForm from '../ApplicationForm';
import ApplicationFormNew from '../ApplicationForm/Application';
import Login from '../Auth/Login';
import LoginOTP from '../Auth/Login/LoginOTP';
import SignUp from '../Auth/SignUp';
import VerifiedOTP from '../Auth/SignUp/VerifiedOTP';
import VerifyEmail from '../Auth/SignUp/VerifyEmail';
import VerifyNumber from '../Auth/SignUp/VerifyNumber';
import Dashboard from '../HomePage/homepageNew';
import OnboardQues from '../OfferLetter/Components/OnboardQues';
import EventsDetails from '../EventsDetails';

export default function MainLayout(props) {
  const [open, setOpen] = React.useState(true);
  const {
    dispatch: dispatchApp,
    state: { isAuthenticated, user, search },
  } = useContext(AuthContext);
  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const theme = useTheme();
  const screenSize = useMediaQuery(theme.breakpoints.down('sm'));
  const isMobileScreen = useMediaQuery(
    theme.breakpoints.down(TABLET_BREAKPOINT)
  );

  const {
    state: { isLoading = false },
    dispatch,
  } = useAppContext();

  const [config, setConfig] = useState();
  const location = useLocation();
  const [swipeableDrawer, setSwipeableDrawer] = useState();
  const isForm =
    location.pathname === '/form' ||
    location.pathname === '/application' ||
    location.pathname === '/thankYou' ||
    location.pathname === '/events' ||
    location.pathname === '/homepage';

  const [idle, setIdle] = useState(false);
  const handleOnIdle = () => {
    setIdle(true);
  };
  const timeout = 1000 * 60 * 10;

  // const methods = useIdleTimer({
  //   timeout,
  //   onIdle: handleOnIdle,
  // });

  useEffect(() => {
    if (idle === true) {
      dispatchApp({
        type: 'LOGOUT',
        payload: {
          user: {},
          token: null,
        },
      });
    }
  }, [idle]);

  React.useEffect(() => {
    getConfig()
      .then((res) => {
        dispatch({ type: 'updateConfig', value: res[0]?.config });
        getAxiosInstance(res);
        setConfig(res[0]?.config);
      })
      .catch((err) => {
        console.log('error in config', err);
      });
  }, []);

  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <>
      <div style={!isForm ? { height: '100%' } : {}}>
        <ErrorBoundary
          FallbackComponent={ErrorFallback}
          onReset={() => {
            // reset the state of your app so the error doesn't happen again
            window.location.reload();
          }}
        >
          <SnackbarProvider autoHideDuration={5000}>
            <Box sx={{ display: 'flex', height: '100%' }}>
              <CssBaseline />
              {!config ? (
                <KenLoader />
              ) : (
                <>
                  {isLoading && <KenLoader />}
                  {isAuthenticated && !isForm && (
                    <>
                      <SideNavigation
                        open={open}
                        handleDrawerClose={handleDrawerClose}
                        handleDrawerOpen={handleDrawerOpen}
                        setSwipeableDrawer={setSwipeableDrawer}
                        swipeableDrawer={swipeableDrawer}
                        setOpen={setOpen}
                      />
                      <MenuAppBar
                        open={open}
                        handleDrawerOpen={handleDrawerOpen}
                        setSwipeableDrawer={setSwipeableDrawer}
                      />
                    </>
                  )}
                  <Box
                    component="main"
                    sx={{
                      flexGrow: 1,
                      margin: isMobileScreen
                        ? '0px'
                        : !isAuthenticated || isForm
                        ? '0px'
                        : screenSize
                        ? '80px - 28px'
                        : '80px 16px',
                      height: !isAuthenticated ? '100%' : 'calc(100% - 160px)',
                      width: isMobileScreen ? '100%' : undefined,
                      paddingTop: isMobileScreen ? '65px' : undefined,
                      //  Note: added following so for main screen the gird is splitted on 12 grid after subtracting side navbar
                      maxWidth:
                        !isMobileScreen && isAuthenticated && !isForm
                          ? open
                            ? 'calc(100% - 260px)'
                            : 'calc(100% - 145px)'
                          : undefined,
                    }}
                  >
                    <Routes>
                      <Route
                        path={'/form'}
                        element={
                          isAuthenticated ? (
                            <ApplicationForm />
                          ) : (
                            <Navigate to="/login" />
                          )
                        }
                      />
                      <Route
                        path={'/application'}
                        element={
                          isAuthenticated ? (
                            <ApplicationFormNew />
                          ) : (
                            <Navigate to="/login" />
                          )
                        }
                      />
                      <Route
                        path={'/'}
                        element={
                          search !== null && search !== '' ? (
                            <Navigate to={`/courses?search=${search}`} />
                          ) : (
                            <Navigate to="/homepage" />
                          )
                        }
                      />
                      <Route
                        path={routes.login}
                        element={
                          isAuthenticated ? (
                            search !== null && search !== '' ? (
                              <Navigate to={`/courses?search=${search}`} />
                            ) : (
                              <Navigate to="/homepage" />
                            )
                          ) : (
                            <Login />
                          )
                        }
                      />
                      <Route
                        path={routes.signup}
                        element={
                          isAuthenticated ? (
                            search !== null && search !== '' ? (
                              <Navigate to={`/courses?search=${search}`} />
                            ) : (
                              <Navigate to="/homepage" />
                            )
                          ) : (
                            <SignUp />
                          )
                        }
                      />
                      <Route
                        path={routes.loginOTP}
                        element={
                          isAuthenticated ? (
                            <Navigate to="/homepage" />
                          ) : (
                            <LoginOTP />
                          )
                        }
                      />
                      {/* <Route
                        exact
                        path={`/feeStructure`}
                        redirectTo="/homepage"
                        element={
                          <KenPrivateRoute
                            id={PERMISSIONS[ROLES.APPLICANT].APP_FEESTRUCTURE}
                          >
                            <FeeStructure />
                          </KenPrivateRoute>
                        }
                      />
                      <Route
                        exact
                        path={`/offerLetter`}
                        redirectTo="/homepage"
                        element={
                          <KenPrivateRoute
                            id={PERMISSIONS[ROLES.APPLICANT].APP_OFFERLETTER}
                          >
                            <OfferLetter />
                          </KenPrivateRoute>
                        }
                      />
                      <Route
                        exact
                        path={`/interviewSlots`}
                        redirectTo="/homepage"
                        element={
                          <KenPrivateRoute
                            id={PERMISSIONS[ROLES.APPLICANT].APP_INTERVIEWSLOTS}
                          >
                            <InterviewSlots />
                          </KenPrivateRoute>
                        }
                      /> */}
                      <Route
                        exact
                        path={`/homepage`}
                        redirectTo="/homepage"
                        element={
                          <KenPrivateRoute
                            id={PERMISSIONS[ROLES.APPLICANT].APP_HOME_NEW}
                          >
                            <Dashboard />
                          </KenPrivateRoute>
                        }
                      />
                      {/* <Route
                        exact
                        path={`/interview`}
                        redirectTo="/homepage"
                        element={
                          <KenPrivateRoute
                            id={PERMISSIONS[ROLES.APPLICANT].APP_INTERVIEW}
                          >
                            <Interview />
                          </KenPrivateRoute>
                        }
                      /> */}
                      {/* <Route
                        exact
                        path={`/offerLetterDetailed`}
                        redirectTo="/homepage"
                        element={
                          <KenPrivateRoute
                            id={
                              PERMISSIONS[ROLES.APPLICANT]
                                .APP_OFFERLETTERDETAILED
                            }
                          >
                            <OfferLetterDetailed />
                          </KenPrivateRoute>
                        }
                      /> */}
                      {/* <Route
                        exact
                        path={`/feeDetails`}
                        redirectTo="/homepage"
                        element={
                          <KenPrivateRoute
                            id={PERMISSIONS[ROLES.APPLICANT].APP_FEEDETAILS}
                          >
                            <FeeDetails />
                          </KenPrivateRoute>
                        }
                      /> */}
                      <Route
                        path={routes.verifyNumber}
                        element={
                          isAuthenticated ? (
                            <Navigate to="/homepage" />
                          ) : (
                            <VerifyNumber />
                          )
                        }
                      />
                      <Route
                        path={routes.verifyEmail}
                        element={
                          isAuthenticated ? (
                            <Navigate to="/homepage" />
                          ) : (
                            <VerifyEmail />
                          )
                        }
                      />
                      <Route
                        path={routes.verifiedOTP}
                        element={
                          isAuthenticated ? (
                            <Navigate to="/homepage" />
                          ) : (
                            <VerifiedOTP />
                          )
                        }
                      />
                      <Route
                        path={routes.newApplication}
                        element={
                          isAuthenticated ? (
                            <Navigate to="/homepage" />
                          ) : (
                            <ApplicationForm />
                          )
                        }
                      />
                      {/* <Route
                        exact
                        path={`/homepage`}
                        redirectTo="/login"
                        element={
                          <KenPrivateRoute
                            id={PERMISSIONS[ROLES.APPLICANT].APP_HOME}
                          >
                            <HomePage />
                          </KenPrivateRoute>
                        }
                      /> */}
                      {/* <Route
                        exact
                        path={`/document`}
                        redirectTo="/login"
                        element={
                          <KenPrivateRoute
                            id={PERMISSIONS[ROLES.APPLICANT].APP_DOCUMENTS}
                          >
                            <DocumentPage />
                          </KenPrivateRoute>
                        }
                      /> */}
                      <Route
                        exact
                        path={`/thankYou`}
                        redirectTo="/homepage"
                        element={
                          <KenPrivateRoute
                            id={PERMISSIONS[ROLES.APPLICANT].APP_THANKYOU}
                          >
                            <ThankYouPage />
                          </KenPrivateRoute>
                        }
                      />
                      <Route
                        exact
                        path={`/events`}
                        redirectTo="/homepage"
                        element={
                          <KenPrivateRoute
                            id={PERMISSIONS[ROLES.APPLICANT].APP_EVENT}
                          >
                            <EventsDetails />
                          </KenPrivateRoute>
                        }
                      />
                      {/* <Route
                        exact
                        path={`/feePayments`}
                        redirectTo="/homepage"
                        element={
                          <KenPrivateRoute
                            id={PERMISSIONS[ROLES.APPLICANT].APP_FEEPAYEMENTS}
                          >
                            <FeePayment />
                          </KenPrivateRoute>
                        }
                      /> */}
                      <Route
                        exact
                        path={`*`}
                        element={
                          isAuthenticated ? (
                            <Navigate to="/homepage" />
                          ) : (
                            <Login />
                          )
                        }
                      />
                      {/* <Route
                        exact
                        redirectTo={routes.login}
                        path={`/courses`}
                        element={
                          <KenPrivateRoute
                            id={PERMISSIONS[ROLES.APPLICANT].APP_COURSES}
                          >
                            <Courses />{' '}
                          </KenPrivateRoute>
                        }
                      /> */}
                      {/* APPLICANT - MY APPLICATIONS */}
                      {/* <Route
                        exact
                        // redirectTo={routes.login}
                        path={`/${routes.myApplications}`}
                        element={
                          <KenPrivateRoute
                            id={PERMISSIONS[ROLES.APPLICANT].APP_APPLICATIONS}
                          >
                            <MyApplications />
                          </KenPrivateRoute>
                        }
                      /> */}
                      <Route
                        exact
                        redirectTo={`/${routes.homepage}`}
                        path={`/${routes.onboardQues}`}
                        element={
                          <KenPrivateRoute
                            id={PERMISSIONS[ROLES.APPLICANT].APP_ONBOARDING}
                          >
                            <OnboardQues />
                          </KenPrivateRoute>
                        }
                      />
                    </Routes>
                  </Box>
                </>
              )}
            </Box>
          </SnackbarProvider>
        </ErrorBoundary>
      </div>
    </>
  );
}
